// src/lib/kinema/core/handlers/playbackHandlers.ts
import type { EditorState, InverseOperation } from '../types';
import { getCompositionProps } from '../types';
import { cloneState } from '../EditorState';

export function handleSetPlayhead(
  state: EditorState,
  payload: { time: number },
): { state: EditorState; inverse: InverseOperation | null } {
  const { duration } = getCompositionProps(state);
  const newState = cloneState(state);
  newState.playheadTime = Math.max(0, Math.min(payload.time, duration));

  return {
    state: newState,
    inverse: null, // playhead movement is transient — never undoable
  };
}
